<div class="main-container">
  <header class="top-header" fxLayout="column" fxLayoutAlign="start start">
    <div class="breadcrumb-nav" (click)="goBack()">
      <h2 mat-button class="header-izvestaj" style="cursor: pointer;">
        <mat-icon>arrow_back</mat-icon>
        Izveštaji
      </h2>
    </div>
    <div class="title-row" (click)="goBack()">
      <h1 class="view-title">{{ reportDetails?.label || 'Izveštaji' }}</h1>
    </div>
  </header>

  <div class="content-body" fxLayout="row" fxLayoutGap="20px">
    <main #fullscreenTarget class="preview-area" style="flex: 2;">
      <header class="doc-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="left-actions" fxLayout="row" fxLayoutGap="8px">
          
          <button mat-flat-button color="primary" class="doc-btn" 
                  [disabled]="isLoading || isPreviewEmpty" 
                  [matMenuTriggerFor]="downloadMenu">
            <span>Preuzmi</span>
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>

          <mat-menu #downloadMenu="matMenu">
            <button mat-menu-item (click)="exportReport('pdf')">
              <mat-icon>picture_as_pdf</mat-icon>
              <span>Format PDF</span>
            </button>
            
            <button mat-menu-item (click)="exportReport('docx')">
              <mat-icon>description</mat-icon>
              <span>Format Word (DOCX)</span>
            </button>

            <button mat-menu-item (click)="exportReport('xlsx')">
              <mat-icon>table_view</mat-icon>
              <span>Format Excel (XLSX)</span>
            </button>
          </mat-menu>

          <button mat-flat-button color="primary" class="doc-btn" 
                  (click)="printPdf()" 
                  [disabled]="isLoading || isPreviewEmpty">
            <mat-icon>print</mat-icon>
            Štampaj
          </button>
        </div>

        <div class="right-actions" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
          <button mat-icon-button class="tool-btn" 
                  (click)="changeZoom(0.1)" 
                  [disabled]="isPreviewEmpty"
                  matTooltip="Uvećaj">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-icon-button class="tool-btn" 
                  (click)="changeZoom(-0.1)" 
                  [disabled]="isPreviewEmpty"
                  matTooltip="Umanji"
                  >
            <mat-icon>remove</mat-icon>
          </button>
          
          <button mat-icon-button class="tool-btn" 
                  (click)="toggleFullScreen()" 
                  [disabled]="isPreviewEmpty"
                  matTooltip="Ceo ekran"
                  >
            <mat-icon>{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>
        </div>
      </header>

      <div class="viewer-content">
        <div *ngIf="isLoading || isPreviewLoading" class="loader-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Učitavanje...</p>
        </div>

        <div *ngIf="!isLoading && !isPreviewLoading && previewError" class="no-data-state" fxLayout="column" fxLayoutAlign="center center">
          <mat-icon class="no-data-icon">error</mat-icon>
          <h3>Greška pri prikazu izveštaja</h3>
          <p>{{ previewError }}</p>
        </div>

        <div *ngIf="!isLoading && !isPreviewLoading && isPreviewEmpty && !hasGeneratedAtLeastOnce" class="no-data">
          <mat-icon class="large-icon">insert_drive_file</mat-icon>
          <p>Generišite parametre u panelu desno za prikaz izveštaja.</p>
        </div>

        <div *ngIf="!isLoading && !isPreviewLoading && isPreviewEmpty && hasGeneratedAtLeastOnce" class="no-data-state" fxLayout="column" fxLayoutAlign="center center">
          <mat-icon class="no-data-icon">search_off</mat-icon>
          <h3>Nema podataka za prikaz</h3>
          <p>Pokušajte sa drugim parametrima o izmenite vremenski period.</p>
        </div>

        <div *ngIf="!isLoading && !isPreviewLoading && reportPreviewHtml" 
             [innerHTML]="reportPreviewHtml" 
             [style.transform]="'scale(' + zoomLevel + ')'"
             class="html-doc-sheet">
        </div>
      </div>
    </main>

    <aside class="sidebar-area" style="flex: 1;">
      <app-report-details 
        *ngIf="inputData?.report"
        [inputData]="inputData"
        (previewUpdated)="handlePreviewUpdate($event)">
      </app-report-details>
      <div *ngIf="isLoading && !inputData?.report" class="sidebar-loader">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    </aside>
  </div>
</div>